export var getRazorPayAccountDetailsMapper = function (data) {
    var results = {};
    if (data && data.result && data.result.length > 0) {
        return {
            totalCount: data.totalCount,
            statusCode: data.statusCode,
            message: data.message,
            result: data.result,
        };
    }
    return results;
};
